import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import i18n from './i18n'
import { I18nextProvider } from 'react-i18next'
import './style.css'
import App from './App'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import LoaderTwo from 'pages/LoaderTwo'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<I18nextProvider i18n={i18n}>
		<Suspense fallback={<LoaderTwo isDataLoading={true} />}>
			<Provider store={store}>
				<App />
			</Provider>
		</Suspense>
	</I18nextProvider>
)
